<template>
  <v-container
    fluid
    class="pa-0"
    :grid-list-md="$vuetify.breakpoint.xsOnly"
    :grid-list-xl="$vuetify.breakpoint.smAndUp"
    fill-height
  >
    <v-layout column class="scrollable">
      <v-flex class="px-2 overflow-auto">
        <v-slide-x-transition mode="out-in">
          <step-1 v-if="state.currentStep === 1" @nextStep="$store.commit('setStep', state.currentStep + 1)"/>
          <step-2 v-if="state.currentStep === 2" @nextStep="$store.commit('setStep', state.currentStep + 1)"/>
          <step-3 v-if="state.currentStep === 3" @nextStep="$router.push({ name: routeNames.RESULT })"/>
        </v-slide-x-transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import routeNames from '@/router/route-names'
import { mapState } from 'vuex'
export default {
  name: routeNames.REFUND,
  data () {
    return {
      routeNames
    }
  },
  components: {
    Step1: () => import('@/components/RefundSteps/Step1.vue'),
    Step2: () => import('@/components/RefundSteps/Step2.vue'),
    Step3: () => import('@/components/RefundSteps/Step3.vue')
  },
  computed: {
    ...mapState(['state'])
  },
  watch: {
    'configuration.configuration': {
      handler: (val) => {
        if (val && !val.refundAvailable) {
          this.$router.push({ name: routeNames.MAIN, params: { instance: this.configuration.instanceId } })
        }
      },
      deep: true
    }
  }
}
</script>
